export default __webpack_public_path__ + "static/media/brother-logo.6ba699f2.png";